import { useGetAssignmentMarksQuery } from "@features/assignmentMarks/assignmentMarksApi";
import AssignmentStatus from "@admin/components/AssignmentMarks/AssignmentStatus";
import AssignmentMarkList from "@admin/components/AssignmentMarks/AssignmentMarkList";

const AssignmentMark = () => {
  const {
    data: assignmentMarks,
    isLoading,
    isError,
  } = useGetAssignmentMarksQuery();

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <AssignmentStatus assignmentMarks={assignmentMarks} />
      <AssignmentMarkList
        assignmentMarks={assignmentMarks}
        isLoading={isLoading}
        isError={isError}
      />
    </div>
  );
};

export default AssignmentMark;
